// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__PzTsv","left":"style_left__jkyg2","title":"style_title__W_hNC","doc":"style_doc__dzilS","docs":"style_docs__2pO67","spin":"style_spin__xVuf3"};